import { SubmissionListItem } from '@data-access/submissions/types';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  updateEntity,
  withEntities,
} from '@ngrx/signals/entities';

const _submissionEntityConfig = () =>
  entityConfig({
    collection: '_submission',
    entity: type<SubmissionListItem>(),
    selectId: (entity) => entity.id,
  });

export const withSubmissionEntities = () => {
  return signalStoreFeature(
    withEntities(_submissionEntityConfig()),
    withMethods(({ ...store }) => ({
      loadSubmissions: (data: SubmissionListItem[]) => {
        return patchState(
          store,
          setAllEntities(data, _submissionEntityConfig()),
        );
      },

      updateSubmission: (
        submissionId: string,
        submission: SubmissionListItem,
      ) => {
        return patchState(
          store,
          updateEntity(
            { id: submissionId, changes: submission },
            _submissionEntityConfig(),
          ),
        );
      },
    })),
  );
};
